import { render, staticRenderFns } from "./time-article.vue?vue&type=template&id=5b9698a4&scoped=true"
import script from "./time-article.vue?vue&type=script&lang=js"
export * from "./time-article.vue?vue&type=script&lang=js"
import style0 from "./time-article.vue?vue&type=style&index=0&id=5b9698a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9698a4",
  null
  
)

export default component.exports